import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const TwoPhaseLockingProtocolModule = () => (
  <QPhototModuleSubtopic
    title="Two-Phase Locking Protocol (2PL)"
    videos={[
      "https://www.youtube.com/embed/1pUaEDNLWi4",
      "https://www.youtube.com/embed/pZExswIjVsk",
      "https://www.youtube.com/embed/z8Yqn91akV8"
    ]}
    takeaways={[]}
    questions={[
      {
        text: "What are some variables of the two-phase locking protocol? Why is strict or rigorous two-phase locking often preferred?"
      },
      {
        text: `Discuss different types of Two-Phase Locking (2PL) algorithms with an example. Consider the following two transactions and schedule (time goes from top to bottom),
i) Demonstrate how Two-Phase Locking (2PL) ensures a conflict-serializable schedule for the transactions mentioned above, using the notation Li[x] to indicate that transaction i acquires a lock on element x and Ui[x] to indicate that transaction i releases its lock on x.
ii) Illustrate how using locks without 2PL can result in a schedule that is not conflict-serializable.`,
        image:"/dbms_25.png"
      },
      {
        text: "Explain why two-phase locking (2PL) is generally not used as a concurrency control method for indexes such as B+ trees. Provide a concrete example to illustrate the limitations of 2PL in this context."
      },
      {
        text: `Discuss the advantages and disadvantages of strict 2PL compared to other concurrency control mechanisms. Show that strict 2PL disallows the following schedule:
R1(X) -> R1(Y) -> R2(X) -> W2(X) -> R2(Y) -> W1(X) -> W1(Y) -> W2(Y) -> C1 -> C2`
      }
    ]}
    exampleVideos={[]}
  />
);

export default TwoPhaseLockingProtocolModule;
